import { useCallback, useMemo } from 'react'

import { toYType } from 'features/utils/useYjsState'
import { Widget, WidgetAdminControlsProps } from 'features/views/LayoutEditor/types'
import { useLayoutEditorContext } from 'features/views/LayoutEditor/useLayoutEditorContext'

type UseLayoutEditorVisibilityFiltersControlStateProps = {
    widget: Widget
    onChange: WidgetAdminControlsProps<Widget>['onChange']
}

export function useLayoutEditorVisibilityFiltersControlState({
    widget,
    onChange,
}: UseLayoutEditorVisibilityFiltersControlStateProps) {
    const { visibilityFilters = [] } = widget.attrs

    const { object, fields } = useLayoutEditorContext()

    const onChangeVisibilityFilters = useCallback(
        (filters: Filter[]) => {
            onChange((attrs) => attrs.set('visibilityFilters', toYType(filters)))
        },
        [onChange]
    )

    return useMemo(
        () => ({
            visibilityFilters,
            onChangeVisibilityFilters,
            object,
            fields,
        }),
        [visibilityFilters, onChangeVisibilityFilters, object, fields]
    )
}
